module.exports = __webpack_public_path__ + "img/hole_number.f0db03bf.svg";